<template>
  <div class="flex-col-start-start pt-6 gap-3" style="height: 100%">
    <v-card
      v-for="item in items"
      :key="item"
      outlined
      class="w-100 px-4 py-4 flex-row-center-center"
      min-height="80px"
      @click="onSelect(item)"
    >
      <Radio :selected="interval === item" :title="`${item} hours`" />
    </v-card>
    <v-spacer></v-spacer>
    <v-btn
      color="text"
      class="white--text w-100"
      width="100%"
      :loading="loading"
      @click="onSubmit"
    >
      {{ $t("calculate") }}
    </v-btn>
  </div>
</template>

<script>
import Radio from "@/components/structure/Radio";

export default {
  name: "PredictionInterval",

  props: {
    interval: { type: Number, required: true },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      items: [5, 8],
    };
  },

  methods: {
    onSubmit() {
      this.$emit("submit");
    },
    onSelect(interval) {
      this.$emit("select", interval);
    },
  },

  components: {
    Radio,
  },
};
</script>
